import { Injectable } from '@angular/core';
import { fromJS, Map } from 'immutable';
import { Document } from '../../../document-data/document.model';

@Injectable()
export class DocumentPreviewBuilder {
  buildDocumentContentWithoutSignatures(): Map<string, any> {
    return fromJS({
      [Document.CONTENT_KEYS.CLIENT_SIGNATURE]: null,
      [Document.CONTENT_KEYS.COMPANY_SIGNATURE]: null,
    });
  }
}
